const stepsDefaultData = [
  { name: "Selfie", active: true, activeImage: "" },
  { name: "Template", active: false, activeImage: "" },
  { name: "Pose", active: false, activeImage: "" },
  { name: "Background", active: false, activeImage: "" },
  { name: "Logo", active: false, activeImage: "" },
  { name: "Text", active: false, activeImage: "" },
  { name: "Download", active: false, activeImage: "" },
]

const defoltData = { person: null, photos: null, template: null, pose: null, background: null, logo: { 1: null, 2: null }, flag: null, num1: "", desc1: "", num2: "", desc2: "", position: "", name: "", surname: "" };


export { stepsDefaultData, defoltData }